import { INIT_URL, SIGNOUT_USER_SUCCESS, USER_DATA, USER_TOKEN_SET, SIGNIN_USER_SUCCESS, SIGNIN_USER_ERROR, SIGNIN_USER_START, AUTH_REFRESH_START, AUTH_REFRESH_SUCCESS, AUTH_REFRESH_ERROR, SIGNOUT_USER_START, FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS, FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR, SET_USER_ROLE, VERIFY_OTP_START, VERIFY_OTP_SUCCESS, VERIFY_OTP_ERROR, UPDATE_MIP_DATA, SET_USER_SITE } from "../../constants/ActionTypes";
import { getUserSessionData, setUserSessionData, GET_USER_SESSION_DATA } from "../actions/userLocalStorageSession";
import { clearWorklistContext } from "../actions/worklistSession";

const INIT_STATE = {
  initURL: '',
  authUser: JSON.parse(sessionStorage.getItem('user')),
  appLoading: true,
  loading: false,
  message: '',
  error: '',
  sessionData: {}
};

export default (state = INIT_STATE, action) => {
  let newAuthUser;
  switch (action.type) {


    case INIT_URL: {
      return { ...state, initURL: action.payload };
    }

    case SIGNOUT_USER_START: {
      return {
        ...state,
        appLoading: true,
      }
    }

    case SIGNOUT_USER_SUCCESS: {
      clearWorklistContext();
      return {
        ...state,
        authUser: null,
        initURL: '',
        appLoading: false
      }
    }

    case SIGNIN_USER_START: {
      return { ...state, error: '', message: '', loading: true };
    }
    case SIGNIN_USER_SUCCESS: {
      return { ...state, error: '', message: '', loading: false };
    }
    case SIGNIN_USER_ERROR: {
      return { ...state, error: '', message: action.payload, loading: false };
    }

    case USER_DATA: {
      const sessionData = getUserSessionData(action.payload.email);
      if (!sessionData) {
        setUserSessionData(action.payload.email, {});
      }
      return {
        ...state,
        authUser: action.payload,
        sessionData: sessionData || {}
      };
    }
    case VERIFY_OTP_START: {
      return {
        ...state,
        submitting: true
      }
    }
    case VERIFY_OTP_SUCCESS: {
      newAuthUser = { ...state.authUser }
      newAuthUser.authenticated = true;
      sessionStorage.setItem('user', JSON.stringify(newAuthUser));
      return {
        ...state,
        submitting: false,
        authUser: { ...newAuthUser }
      }
    }
    case VERIFY_OTP_ERROR: {
      return {
        ...state,
        submitting: false
      }
    }
    case VERIFY_OTP_ERROR: {
      return {
        ...state,
        submitting: false
      }
    }

    case AUTH_REFRESH_START: {
      return { ...state, appLoading: true };
    }

    case AUTH_REFRESH_SUCCESS: {
      return { ...state, appLoading: false };
    }
    case AUTH_REFRESH_ERROR: {
      return { ...state, appLoading: false };
    }

    case GET_USER_SESSION_DATA: {
      const sessionData = getUserSessionData(action.email);
      if (!sessionData) {
        setUserSessionData(action.email, {});
      }
      return {
        ...state,
        sessionData: sessionData || {}
      };
    }

    case FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.risWithMips = action.risWithMips || [];
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }

    case FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.risWithMips = [];
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }

    case SET_USER_ROLE: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.role = action.role;
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));
      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }

    case SET_USER_SITE: {
      let newAuthUser = { ...state.authUser };
      newAuthUser.site = action.site;
      sessionStorage.setItem("user", JSON.stringify(newAuthUser));

      return {
        ...state,
        authUser: { ...newAuthUser }
      };
    }
      
    case UPDATE_MIP_DATA: {
      const modifiedMips = state.authUser.mips.map((mip) => {
        if (mip.mipId === action.payload.mipId) {          
          return { ...mip, ...action.payload };
        }
        return mip;
      })
      
      return { ...state, loading: true, authUser: {...state.authUser, mips: modifiedMips} };
    }

    default:
      return state;
  }
}
